import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/config/app";

import type { LocationData } from "./types";

export const apiLocations = {
  async getAddressOptionsById(id: string): Promise<LocationData> {
    const response = await apiClient.get<LocationData>(
      `${API_ENDPOINTS.ADMIN}/locations/address-options?cityId=${id}`
    );
    return response;
  },
};
